/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import EditTemplate from "./features/edittemplate";

const AddBotTemplate = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <EditTemplate />
        </section>
      </Layout>
    </>
  );
};
export default AddBotTemplate;
